import React, { useCallback } from 'react'
import { IframeContainerStyled, IframeStyled } from './styles'
import { IframeProps } from './types'

const Iframe: React.FC<IframeProps> = ({ data }) => {
  const { iframe, script } = data

  const handleScriptContainerRef = useCallback(
    (node) => {
      if (!node || !script) {
        return
      }

      const scriptElement = document.createElement('script')

      for (const [key, value] of Object.entries(script)) {
        scriptElement.setAttribute(key, value)
      }

      node.appendChild(scriptElement)
    },
    [script]
  )

  return (
    <IframeContainerStyled>
      {iframe && <IframeStyled dangerouslySetInnerHTML={{ __html: iframe }} />}
      <div ref={handleScriptContainerRef}></div>
    </IframeContainerStyled>
  )
}

export default Iframe
